import { useSetupProgress as useSetupProgressFeature, CHECKLIST_ITEMS as CHECKLIST_ITEMS_FEATURE } from '../features/cliniko/useSetupProgress';

export const CHECKLIST_ITEMS = CHECKLIST_ITEMS_FEATURE;

export default function useSetupProgress() {
  return useSetupProgressFeature();
}
